import { CartProduct } from "@/interfaces";
import { formatCurrency, isFunction } from "@/utils";
import { CartHelper } from "@/helpers";
import CartProductItem from "../CartProductItem";
import Counter from "../Counter";
import * as S from "./styles";
import Link from "@mui/material/Link";
import { colors } from "@/theme";
import shippingIcon from "@/assets/shipping-icon.svg";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import quantityShipIcon from "@/assets/quantity-ship-icon.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useCart, useSettings } from "@/contexts";
import Box from "@mui/material/Box";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

export type CartItemProps = {
  item?: CartProduct;
  defaultProductImageUrl?: string;
  onQuantityChange?: (id: number, value: number, type?: "in-store" | "shipping") => void;
  onCoopAppliedChange?: (id: number, value: number) => void;
  itemType?: "in-store" | "shipping";
};

const DialogCounter: React.FC<{
  label: string;
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
}> = ({ label, value, onIncrement, onDecrement }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
      <IconButton onClick={onDecrement}>
        <RemoveIcon />
      </IconButton>
      <div>{label}: {value}</div>
      <IconButton onClick={onIncrement}>
        <AddIcon />
      </IconButton>
    </div>
  );
};

// const DialogCounter: React.FC<{
//   value: number;
//   onChange: (value: number) => void;
//   maxValue?: number;
// }> = ({ value, onChange, maxValue }) => {
//   return (
//     <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//       <IconButton
//         onClick={() => onChange(Math.max(0, value - 1))}
//         sx={{
//           padding: "8px",
//           marginRight: "8px",
//         }}
//       >
//         <RemoveIcon sx={{ fontSize: 20, color: colors.neutralGrey800 }} />
//       </IconButton>
//       <div
//         style={{
//           minWidth: "40px",
//           textAlign: "center",
//           fontSize: "16px",
//           fontWeight: 500,
//           color: colors.neutralGrey800,
//           fontFamily: "PF DIN Text Pro",
//         }}
//       >
//         {value}
//       </div>
//       <IconButton
//         onClick={() => onChange(Math.min(maxValue || Infinity, value + 1))}
//         sx={{
//           padding: "8px",
//           marginLeft: "8px",
//         }}
//       >
//         <AddIcon sx={{ fontSize: 20, color: colors.neutralGrey800 }} />
//       </IconButton>
//     </div>
//   );
// };

const CartItem: React.FC<CartItemProps> = ({
  item = undefined,
  defaultProductImageUrl = undefined,
  onQuantityChange,
  onCoopAppliedChange = undefined,
  itemType = "in-store",
}) => {
  const [shippingDialogOpen, setShippingDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [tempShippingQuantity, setTempShippingQuantity] = useState(0);
  const [inStoreQuantity, setInStoreQuantity] = useState(item?.quantity || 0);
  const [shippingQuantity, setShippingQuantity] = useState(item?.shippingQuantity || 0);
  const [editedRetailPrice, setEditedRetailPrice] = useState(item?.price || 0);

  const { settings } = useSettings();
  const { setProductPrice, cart, setItemDiscount, clearItemDiscount } = useCart();

  const [discountDialogOpen, setDiscountDialogOpen] = useState(false);
  const [discountConfig, setDiscountConfig] = useState<{
    type: "amount" | "percentage";
    value: number;
  }>(
    item?.itemDiscountConfig ?? { type: "amount", value: 0 }
  );
  const [discountNote, setDiscountNote] = useState<string>(item?.itemDiscountComment ?? "");

  const orderLevelDiscountActive = (cart?.discount || 0) > 0 || (cart?.offSiteDiscount || 0) > 0;
  const itemDiscountAmount = item?.itemDiscount || 0;
  const itemSubtotal = CartHelper.getItemSubtotal(item);
  const previewItemDiscount = item
    ? CartHelper.resolveItemDiscountAmount(item, discountConfig)
    : 0;

  const handleOpenDiscountDialog = () => {
    setDiscountConfig(item?.itemDiscountConfig ?? { type: "amount", value: 0 });
    setDiscountNote(item?.itemDiscountComment ?? "");
    setDiscountDialogOpen(true);
  };

  const handleApplyItemDiscount = () => {
    if (!item?.productId) return;
    const amount = CartHelper.resolveItemDiscountAmount(item, discountConfig);
    if (amount > itemSubtotal) {
      alert("Discount cannot be greater than the item subtotal");
      return;
    }
    setItemDiscount?.(item.productId, amount, discountConfig, discountNote);
    setDiscountDialogOpen(false);
  };

  const handleRemoveItemDiscount = () => {
    if (!item?.productId) return;
    clearItemDiscount?.(item.productId);
    setDiscountConfig({ type: "amount", value: 0 });
    setDiscountNote("");
    setDiscountDialogOpen(false);
  };

  const handleIncreaseShipping = () => {
    console.log("handleIncreaseShipping: ", inStoreQuantity)
    if (inStoreQuantity > 0) {
      setInStoreQuantity(prev => prev - 1);
      setShippingQuantity(prev => prev + 1);
    }
  };

  const handleIncreaseInStore = () => {

    console.log("handleIncreaseInStore: ", shippingQuantity)
    if (shippingQuantity > 0) {
      setShippingQuantity(prev => prev - 1);
      setInStoreQuantity(prev => prev + 1);
    }
  };

  // const handleShippingDone = () => {
  //   console.log("handleShippingDone")
  //   if(!onQuantityChange) return;

  //   onQuantityChange(tempShippingQuantity, inStoreQuantity, "in-store");
  //   onQuantityChange(tempShippingQuantity, shippingQuantity, "shipping");
  //   setShippingDialogOpen(false);
  // };

  const handleShippingDone = () => {
    console.log("handleShippingDone");
    if (!onQuantityChange) return;

    onChange(inStoreQuantity, onQuantityChange, "in-store");
    onChange(shippingQuantity, onQuantityChange, "shipping");

    setShippingDialogOpen(false);
  };

  const onChange = (
    value: number,
    fn?: Function,
    type?: "in-store" | "shipping"
  ) => {
    if (isNaN(item?.productId as number) || isNaN(value) || !isFunction(fn)) {
      return;
    }

    console.log("onChange Items: ", value, " Type: ", type)
    fn?.(item?.productId as number, value, type);
  };

  const handleOpenShippingDialog = () => {
    setTempShippingQuantity(item?.shippingQuantity || 0);
    setShippingDialogOpen(true);
  };

  // const handleShippingDone = () => {
  //   onChange(tempShippingQuantity, onQuantityChange, "shipping");
  //   setShippingDialogOpen(false);
  // };

  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setEditDialogOpen(true);
  };

  const handleEditClose = () => {
    console.log("Edit clicked for product:", item);
    setEditDialogOpen(false);
    if (item?.productId) {
      setProductPrice(item.productId, editedRetailPrice); // ✅ Updates price + triggers co-op recalculation
    }
  };

  useEffect(() => {
    if (item) {
      console.log("Quantities: -InStore: ", item.quantity, " -Shipping: ", item.shippingQuantity);
      setInStoreQuantity(item.quantity || 0);
      setShippingQuantity(item.shippingQuantity || 0);
      setEditedRetailPrice(item.price || 0);
    }
  }, [item?.quantity, item?.shippingQuantity, item?.price]);


  return item ? (
    <S.CartItemRow>
      <S.CartItemProduct>
        <CartProductItem
          item={item}
          defaultProductImageUrl={defaultProductImageUrl}
          badge={false}
        />
      </S.CartItemProduct>
      <S.CartItemInfoBlock>
        <S.CartItemName>
          {item.productDescription}
          <BorderColorOutlinedIcon
            sx={{ fontSize: 20, marginLeft: 1, color: colors.neutralGrey800, cursor: 'pointer' }}
            onClick={handleEditClick}
          />
        </S.CartItemName>
        <S.CartItemSku style={{ fontFamily: "PF DIN Text Pro" }}>
          SKU# {item.sku}
        </S.CartItemSku>
        <S.CartItemPriceInfo style={{ fontFamily: "PF DIN Text Pro" }}>
          <span>{formatCurrency(item.price || 0)} Retail</span>
          {/* <span>
            {formatCurrency((item.price || 0) - ((item.price || 0) * (settings?.coopEligible || 0)))} w/ Co-Op</span> */}
        </S.CartItemPriceInfo>
      </S.CartItemInfoBlock>
      <S.CartItemCounter>
        <Counter
          value={
            itemType === "in-store" ? item.quantity : item.shippingQuantity
          }
          onChange={(value: number) =>
            onChange(value, onQuantityChange, itemType)
          }
        />
      </S.CartItemCounter>
      <S.CartItemShipping>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-start" }}>
          <Link
            href="#"
            underline="none"
            sx={{
              color: "#1a73e8",
              fontWeight: 500,
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontFamily: "PF DIN Text Pro",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleOpenShippingDialog();
            }}
          >
            <img
              src={shippingIcon}
              alt="Shipping"
              style={{ width: "16px", height: "16px" }}
            />
            Change Shipping
          </Link>
          <Link
            href="#"
            underline="none"
            sx={{
              color: orderLevelDiscountActive ? colors.neutralGrey500 : "#1a73e8",
              pointerEvents: orderLevelDiscountActive ? "none" : "auto",
              fontWeight: 500,
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontFamily: "PF DIN Text Pro",
            }}
            title={
              orderLevelDiscountActive
                ? "Remove the Order Level Discount to set item discounts"
                : undefined
            }
            onClick={(e) => {
              e.preventDefault();
              if (orderLevelDiscountActive) return;
              handleOpenDiscountDialog();
            }}
          >
            <LocalOfferOutlinedIcon sx={{ fontSize: 16 }} />
            {itemDiscountAmount > 0 ? "Edit Discount" : "Item Discount"}
          </Link>
        </div>
      </S.CartItemShipping>
      <S.CartItemSubtotalInfo>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            // height: "60px",
            gap: "10px",
            textAlign: "right",
            width: "100%",
            fontFamily: "PF DIN Text Pro",
          }}
        >
          {(() => {
            const sectionSubtotal =
              itemType === "in-store"
                ? CartHelper.getItemInStoreSubtotal(item)
                : CartHelper.getItemShippedSubtotal(item);
            const sectionCoop =
              itemType === "in-store" ? (item.coopInStore || 0) : (item.coopShipping || 0);
            const proratedItemDiscount =
              itemDiscountAmount > 0 && itemSubtotal > 0
                ? (itemDiscountAmount * sectionSubtotal) / itemSubtotal
                : 0;
            const finalPrice = sectionSubtotal - sectionCoop - proratedItemDiscount;
            return (
              <>
                <div>
                  <div
                    style={{
                      color: colors.neutralGrey800,
                      fontSize: 16,
                      fontWeight: 400,
                      fontFamily: "PF DIN Text Pro",
                    }}
                  >
                    {formatCurrency(sectionSubtotal)} Retail
                  </div>
                  <div
                    style={{
                      color: colors.neutralGrey800,
                      fontSize: 16,
                      fontWeight: 400,
                      fontFamily: "PF DIN Text Pro",
                    }}
                  >
                    -{formatCurrency(sectionCoop)} Co-Op
                  </div>
                  {proratedItemDiscount > 0 && (
                    <div
                      style={{
                        color: colors.neutralGrey800,
                        fontSize: 16,
                        fontWeight: 400,
                        fontFamily: "PF DIN Text Pro",
                      }}
                    >
                      -{formatCurrency(proratedItemDiscount)} Discount
                    </div>
                  )}
                </div>
                <div
                  style={{
                    color: colors.primaryOzone500,
                    fontWeight: 700,
                    fontSize: 24,
                    marginTop: 8,
                    fontFamily: "PF DIN Text Pro",
                  }}
                >
                  {formatCurrency(finalPrice)}
                </div>
              </>
            );
          })()}
        </div>
      </S.CartItemSubtotalInfo>

      {/* Shipping Method Dialog */}
      <Dialog
        open={shippingDialogOpen}
        onClose={() => setShippingDialogOpen(false)}
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "8px",
            overflow: "hidden",
            padding: 0,
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 600,
            fontSize: 16,
            position: "relative",
            p: 2,
            fontFamily: "PF DIN Text Pro",
            color: colors.neutralGrey800,
          }}
        >
          Change Shipping Method
          <IconButton
            aria-label="close"
            onClick={() => setShippingDialogOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CancelIcon sx={{ color: colors.primaryOzone500 }} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 3,
            pb: 0,
          }}
        >
          <div
            style={{
              width: 335,
              height: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
              border: "1px solid #eee",
              borderRadius: 8,
              marginBottom: 16,
            }}
          >
            {item && (
              <img
                src={item.productImageUrl || defaultProductImageUrl}
                alt={item.productDescription}
                title={item.productDescription}
                style={{
                  width: 185,
                  height: 184,
                  objectFit: "contain",
                  display: "block",
                }}
              />
            )}
          </div>
          <div
            style={{
              width: "335px",
              textAlign: "left",
              fontWeight: 600,
              fontSize: 18,
              marginBottom: 2,
              fontFamily: "PF DIN Text Pro",
              color: colors.neutralGrey800,
              textTransform: "capitalize",
            }}
          >
            {item?.productDescription}
          </div>
          <div
            style={{
              width: "335px",
              textAlign: "left",
              color: colors.neutralGrey800,
              fontSize: 13,
              marginBottom: 16,
              fontFamily: "PF DIN Text Pro",
            }}
          >
            SKU# {item?.sku}
          </div>
          <div
            style={{
              width: "335px",
              display: "flex",
              alignItems: "center",
              marginBottom: 12,
              marginLeft: 0,
              fontFamily: "PF DIN Text Pro",
              color: colors.neutralGrey800,
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: 500,
                fontSize: 14,
                fontFamily: "PF DIN Text Pro",
              }}
            >
              <ShoppingCartOutlinedIcon
                sx={{
                  fontSize: 18,
                  marginRight: "4px",
                  color: colors.neutralGrey800,
                }}
              />
              Quantity In-Store
            </span>
            <div style={{ flex: 1 }} />
            <DialogCounter
              label="In Store"
              value={inStoreQuantity}
              // onChitem.quantityange={(value) =>
              //   onChange(value, onQuantityChange, "in-store")
              // }

              onIncrement={handleIncreaseInStore}
              onDecrement={handleIncreaseShipping}
            />
          </div>
          <div
            style={{
              width: "335px",
              display: "flex",
              alignItems: "center",
              marginBottom: 12,
              fontFamily: "PF DIN Text Pro",
              color: colors.neutralGrey800,
            }}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: 500,
                fontSize: 14,
                marginRight: 8,
                fontFamily: "PF DIN Text Pro",
              }}
            >
              <img
                src={quantityShipIcon}
                alt="To Ship"
                style={{ width: 18, height: 18, marginRight: 4 }}
              />
              Quantity to Ship
            </span>
            <div style={{ flex: 1 }} />
            <DialogCounter
              label="To Ship"
              value={shippingQuantity}
              // onChange={(value) => setTempShippingQuantity(value)}
              // maxValue={item.quantity}

              onIncrement={handleIncreaseShipping}
              onDecrement={handleIncreaseInStore}
            />
          </div>
        </DialogContent>
        <Button
          variant="contained"
          onClick={handleShippingDone}
          sx={{
            width: "100%",
            borderRadius: 0,
            py: 2,
            fontWeight: 500,
            fontSize: "16px",
            background: colors.primaryOzone500,
            boxShadow: "none",
            fontFamily: "PF DIN Text Pro",
            color: colors.white,
            "&:hover": {
              background: colors.primaryOzone500,
              boxShadow: "none",
            },
          }}
        >
          Done
        </Button>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditClose}
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "8px",
            overflow: "hidden",
            padding: 0,
            width: "100%",
            maxWidth: "400px"
          },
        }}
      >
        <DialogTitle
          sx={{
            padding: "16px",
            position: "relative",
            textAlign: "center",
            fontFamily: "PF DIN Text Pro",
            fontSize: "18px",
            fontWeight: 500,
            color: colors.neutralGrey800,
          }}
        >
          Edit Item
          <IconButton
            onClick={handleEditClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: colors.primaryOzone500,
            }}
          >
            <CancelIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <Box sx={{ p: 3 }}>
            <Box sx={{
              width: "100%",
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 3,
              bgcolor: colors.white,
              border: `1px solid ${colors.neutralGrey200}`,
              borderRadius: 1,
            }}>
              <img
                src={item.productImageUrl || defaultProductImageUrl}
                alt={item.productDescription}
                style={{
                  maxWidth: "80%",
                  maxHeight: "80%",
                  objectFit: "contain"
                }}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <div style={{
                fontSize: "22px",
                fontWeight: 500,
                color: colors.neutralGrey800,
                marginBottom: "4px",
                fontFamily: "PF DIN Text Pro",
              }}>
                {item.productDescription}
              </div>
              <div style={{
                fontSize: "12px",
                color: colors.neutralGrey600,
                fontFamily: "PF DIN Text Pro",
              }}>
                SKU# {item.sku}
              </div>
            </Box>
            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 3,
            }}>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: colors.neutralGrey800,
                fontFamily: "PF DIN Text Pro",
              }}>
                {formatCurrency(item.price || 0)} Retail
              </Typography>
              <TextField
                placeholder="Enter New Amount"
                variant="outlined"
                autoFocus
                size="small"
                value={editedRetailPrice}
                onChange={(e) => setEditedRetailPrice(parseFloat(e.target.value) || 0)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleEditClose();
                  }
                }}
                sx={{
                  flex: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    backgroundColor: colors.white,
                    "& fieldset": {
                      borderColor: colors.neutralGrey300,
                    },
                  },
                  "& input": {
                    fontFamily: "PF DIN Text Pro",
                  },
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <Button
          onClick={handleEditClose}
          variant="contained"
          fullWidth
          sx={{
            bgcolor: colors.primaryOzone500,
            color: colors.white,
            py: 2,
            borderRadius: 0,
            fontSize: "16px",
            fontWeight: 500,
            textTransform: "none",
            fontFamily: "PF DIN Text Pro",
            "&:hover": {
              bgcolor: colors.primaryOzone500,
            },
          }}
        >
          Update Item
        </Button>
      </Dialog>

      {/* Item Discount Dialog */}
      <Dialog
        open={discountDialogOpen}
        onClose={() => setDiscountDialogOpen(false)}
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            p: 0,
            background: "#fff",
            boxShadow: 24,
            minWidth: 400,
            width: 400,
            overflow: "visible",
          },
        }}
      >
        <Box sx={{ p: 0, width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              pt: 3,
              pb: 2,
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 22,
                color: "#223354",
                fontFamily: "PF DIN Text Pro",
                textAlign: "center",
                flex: 1,
              }}
            >
              Item Discount
            </Typography>
            <IconButton
              onClick={() => setDiscountDialogOpen(false)}
              sx={{
                position: "absolute",
                right: 24,
                top: "50%",
                transform: "translateY(-50%)",
                background: colors.white,
              }}
            >
              <CancelIcon
                sx={{ color: colors.primaryOzone500, cursor: "pointer" }}
                style={{ width: 30, height: 30 }}
              />
            </IconButton>
          </Box>
          <Box sx={{ borderBottom: "1px solid #E0E0E0", mb: 0.5 }} />
          <Box
            sx={{
              px: 3,
              pt: 1,
              pb: 1,
              textAlign: "center",
              color: colors.neutralGrey600,
              fontFamily: "PF DIN Text Pro",
              fontSize: 14,
            }}
          >
            {item.productDescription}
            <div style={{ fontSize: 12, marginTop: 2 }}>
              Subtotal: {formatCurrency(itemSubtotal)}
            </div>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
              mb: 3,
              position: "relative",
            }}
          >
            <Box
              sx={{
                fontWeight: discountConfig.type === "amount" ? 700 : 500,
                fontSize: 18,
                color: discountConfig.type === "amount" ? "#223354" : "#A0A4AD",
                fontFamily: "PF DIN Text Pro",
                px: 2,
                pb: 1,
                cursor: "pointer",
                borderBottom:
                  discountConfig.type === "amount"
                    ? "3px solid #0074FF"
                    : "3px solid transparent",
                transition: "border-color 0.2s",
                mr: 2,
              }}
              onClick={() =>
                setDiscountConfig((prev) => ({ ...prev, type: "amount" }))
              }
            >
              Amount
            </Box>
            <Box
              sx={{
                fontWeight: discountConfig.type === "percentage" ? 700 : 500,
                fontSize: 18,
                color:
                  discountConfig.type === "percentage" ? "#223354" : "#A0A4AD",
                fontFamily: "PF DIN Text Pro",
                px: 2,
                pb: 1,
                cursor: "pointer",
                borderBottom:
                  discountConfig.type === "percentage"
                    ? "3px solid #0074FF"
                    : "3px solid transparent",
                transition: "border-color 0.2s",
              }}
              onClick={() =>
                setDiscountConfig((prev) => ({ ...prev, type: "percentage" }))
              }
            >
              Percentage
            </Box>
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                height: "1px",
                bgcolor: "#E0E0E0",
                zIndex: 0,
              }}
            />
          </Box>
          <Box
            sx={{
              px: 5,
              pb: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              value={discountConfig.value === 0 ? "" : discountConfig.value}
              placeholder={"0.00"}
              onChange={(e) => {
                const value = e.target.value.replace(/[^\d.]/g, "");
                const parts = value.split(".");
                if (parts.length > 2) return;
                if (parts[1] && parts[1].length > 2) return;
                setDiscountConfig((prev) => ({
                  ...prev,
                  value: Number(value) || 0,
                }));
              }}
              InputProps={{
                startAdornment:
                  discountConfig.type === "amount" ? (
                    <span
                      style={{
                        marginRight: 8,
                        color: "#B0B4BB",
                        fontWeight: 500,
                        fontSize: 22,
                      }}
                    >
                      $
                    </span>
                  ) : undefined,
                endAdornment:
                  discountConfig.type === "percentage" ? (
                    <span
                      style={{
                        marginLeft: 8,
                        color: "#B0B4BB",
                        fontWeight: 500,
                        fontSize: 22,
                      }}
                    >
                      %
                    </span>
                  ) : undefined,
                sx: {
                  alignSelf: "center",
                  fontSize: 22,
                  width: "50%",
                  fontWeight: 500,
                  background: "#fff",
                  fontFamily: "PF DIN Text Pro",
                  borderRadius: "12px",
                  height: 56,
                  "& input": {
                    textAlign: "center",
                    fontSize: 22,
                    fontWeight: 500,
                    color: "#223354",
                    padding: "16px 0",
                  },
                },
              }}
              sx={{
                mb: 2,
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "none",
              }}
              inputProps={{ inputMode: "decimal" }}
            />
            <Box
              sx={{
                fontFamily: "PF DIN Text Pro",
                fontSize: 14,
                color: colors.neutralGrey600,
                mb: 2,
              }}
            >
              Discount preview: {formatCurrency(previewItemDiscount)}
            </Box>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={discountNote}
              onChange={(e) => setDiscountNote(e.target.value)}
              placeholder="Enter a note"
              sx={{
                mb: 3,
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "none",
                border: "1px solid #E0E0E0",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  background: "#fff",
                  "& fieldset": { borderColor: "#E0E0E0" },
                },
                "& textarea": {
                  fontFamily: "PF DIN Text Pro",
                  fontSize: 16,
                },
              }}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 0 }}>
            {itemDiscountAmount > 0 && (
              <Button
                onClick={handleRemoveItemDiscount}
                fullWidth
                sx={{
                  background: "#E53912",
                  color: "#fff",
                  borderRadius: "0 0 0 16px",
                  fontWeight: 500,
                  fontSize: 18,
                  fontFamily: "PF DIN Text Pro",
                  py: 2,
                  boxShadow: "none",
                  textTransform: "none",
                  "&:hover": { background: "#b71c00" },
                }}
              >
                Remove
              </Button>
            )}
            <Button
              onClick={handleApplyItemDiscount}
              fullWidth
              sx={{
                background: "#0074FF",
                color: "#fff",
                borderRadius:
                  itemDiscountAmount > 0 ? "0 0 16px 0" : "0 0 16px 16px",
                fontWeight: 500,
                fontSize: 20,
                fontFamily: "PF DIN Text Pro",
                py: 2,
                boxShadow: "none",
                textTransform: "none",
                "&:hover": { background: "#0059c1" },
              }}
            >
              {itemDiscountAmount > 0 ? "Update" : "Add Discount"}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </S.CartItemRow>
  ) : null;
};

export default CartItem;